import type { NewsItem } from '@/types';

export const newsList: NewsItem[] = [
  {
    id: 'n001',
    title: '《长夜星河》收官获口碑逆袭，权谋叙事为何再次打动观众',
    date: '2025-10-14',
    author: '影视观察局',
    cover: 'https://readdy.ai/api/search-image?query=editorial%20photo%20of%20an%20ancient%20Chinese%20palace%20corridor%20at%20night%20lit%20by%20warm%20lanterns%2C%20deep%20indigo%20blue%20tones%2C%20cinematic%20depth%20of%20field%2C%20elegant%20and%20mysterious%20mood%2C%20no%20text&width=1200&height=800&seq=news-cover-01&orientation=landscape',
    summary:
      '随着大结局播出，《长夜星河》评分一路攀升至 9.1。扎实的人物弧光与克制的权谋表达，让这部古装剧成为本季度最大黑马。',
    content:
      '随着《长夜星河》大结局的播出，该剧的评分在短短三天内从 8.4 攀升至 9.1，成为本季度国产剧市场最大的一匹黑马。\n\n与近年流行的快节奏"爽剧"不同，《长夜星河》选择了一条更为克制的叙事路径。剧集将大量笔墨放在人物的动机与抉择上，寒门书生陆祈年从"求存"到"求道"的转变，被处理得层层递进、有迹可循。观众在弹幕里写道："他每一次退让，都是为了下一次更坚定的前进。"\n\n导演沈牧在接受采访时表示，团队在剧本阶段花了近一年时间为每个主要角色撰写"人物前史"，即便这些内容最终不会出现在荧幕上，也保证了角色行为逻辑的自洽。\n\n值得注意的是，该剧在美术与摄影上同样收获好评。大量夜景戏采用实景与数字绘景结合的方式，营造出既恢弘又压抑的东方美学。服化道团队对纹样、器物的考据，也被不少观众称作"细节控的狂欢"。\n\n业内人士分析，《长夜星河》的成功说明，观众对古装权谋题材的需求并未消退，只是对"讲得是否认真"提出了更高要求。',
    tags: ['专题', '古装', '剧评'],
  },
  {
    id: 'n002',
    title: '本季度新剧排播一览：多部悬疑题材集中上线',
    date: '2025-10-12',
    author: '漂亮的姐姐 编辑部',
    cover: 'https://readdy.ai/api/search-image?query=atmospheric%20foggy%20city%20street%20at%20night%20with%20glowing%20neon%20signs%20and%20wet%20asphalt%20reflections%2C%20cold%20teal%20and%20crimson%20tones%2C%20cinematic%20suspense%20mood%2C%20no%20text&width=1200&height=800&seq=news-cover-02&orientation=landscape',
    summary:
      '从刑侦到心理惊悚，本季度共有六部悬疑题材剧集陆续上线。我们整理了一份排播时间表，方便你提前安排追剧计划。',
    content:
      '本季度堪称悬疑爱好者的"丰收季"。从刑侦推理到心理惊悚，共有六部悬疑题材剧集陆续与观众见面。\n\n打头阵的是《雾城谜案》，该剧以一桩跨越十年的连环旧案为核心，采用双线叙事结构，上线首周便登顶热度榜。紧随其后的是心理惊悚剧《暗房》，以摄影师视角切入，探索记忆与真实之间的模糊地带。\n\n此外，两部海外悬疑剧也将在本月上线，其中包括备受期待的律政题材《沉默的证词》。该剧以一场"沉默的庭审"为切口，讨论程序正义与实体正义之间的张力。\n\n为方便读者安排追剧计划，我们整理了详细的排播时间表，包含每部剧的上线日期、更新节奏与集数信息，可在电视剧分类页查看完整列表。',
    tags: ['资讯', '悬疑', '排播'],
  },
  {
    id: 'n003',
    title: '苏晚棠凭《长夜星河》再获关注，谈塑造"落魄郡主"的心路',
    date: '2025-10-10',
    author: '星闻速递',
    cover: 'https://readdy.ai/api/search-image?query=elegant%20editorial%20scene%20with%20a%20traditional%20Chinese%20golden%20hairpin%20and%20silk%20fan%20on%20a%20dark%20wood%20table%2C%20warm%20amber%20lighting%2C%20refined%20oriental%20aesthetic%2C%20no%20text&width=1200&height=800&seq=news-cover-03&orientation=landscape',
    summary:
      '从默默无闻到被观众记住名字，苏晚棠用一部古装剧证明了自己的可塑性。她坦言："这个角色让我学会了收着演。"',
    content:
      '《长夜星河》热度持续走高，剧中饰演落魄郡主苏晚棠的演员也再次走进大众视野。\n\n在谈及角色塑造时，她表示最大的挑战在于"收着演"："郡主这个人物外表柔弱，内心却极其坚韧。如果演得太满，反而会失去那份隐忍的力量感。"为此，她在拍摄期间查阅了大量关于古代女性生活状态的资料，甚至专门练习了如何在不借助台词的情况下，仅靠眼神传递情绪。\n\n剧组工作人员透露，苏晚棠在片场几乎不离开角色状态，即兴加入的许多细微动作，最终都被保留进了成片。\n\n对于观众的认可，她显得格外平静："被记住名字是一件很珍贵的事，但我更希望被记住的是角色本身。"',
    tags: ['演员动态', '古装', '访谈'],
  },
  {
    id: 'n004',
    title: '《雾城谜案》双线叙事引热议，编剧回应结局争议',
    date: '2025-10-08',
    author: '影视观察局',
    cover: 'https://readdy.ai/api/search-image?query=moody%20noir%20photo%20of%20a%20detectives%20desk%20with%20case%20files%2C%20old%20photographs%20and%20a%20single%20desk%20lamp%2C%20cold%20blue%20grey%20tones%2C%20shadowy%20and%20tense%20atmosphere%2C%20no%20text&width=1200&height=800&seq=news-cover-04&orientation=landscape',
    summary:
      '围绕《雾城谜案》开放式结局的讨论仍在发酵。编剧郑砚舟首次公开回应："我们想保留一点让观众自己判断的空间。"',
    content:
      '《雾城谜案》播出过半，围绕其开放式结局的讨论在社交平台上持续发酵。有观众认为结局"留白过多"，也有观众表示这样的处理恰恰强化了整部剧的宿命感。\n\n编剧郑砚舟在近日的一场直播中首次公开回应："我们并非刻意制造悬念，而是希望把最后一步交给观众。真相有时不止一个版本，重要的是你愿意相信哪一个。"\n\n他同时透露，剧本在创作阶段曾准备过一个"完整解答版"结局，但最终团队一致认为，留白更能呼应全剧关于"记忆与选择"的核心主题。\n\n该剧目前评分稳定在 9.3，多个平台的讨论热度仍在上升。对于是否会有第二季，制片方暂未给出明确回应。',
    tags: ['资讯', '悬疑', '剧评'],
  },
  {
    id: 'n005',
    title: '行业观察：国产都市剧正在"去爽感化"？',
    date: '2025-10-05',
    author: '漂亮的姐姐 编辑部',
    cover: 'https://readdy.ai/api/search-image?query=modern%20city%20skyline%20at%20blue%20hour%20seen%20through%20abstract%20glass%20architecture%2C%20cool%20azure%20and%20grey%20tones%2C%20clean%20minimal%20editorial%20composition%2C%20no%20text&width=1200&height=800&seq=news-cover-05&orientation=landscape',
    summary:
      '从《逆光而行》到《季风起时》，越来越多都市剧开始弱化"逆袭爽感"，转而描摹真实的成长困境。这是行业的一次集体转向吗？',
    content:
      '过去几年，"逆袭"几乎成为都市剧的标准配方：主角必受尽委屈，再以一记漂亮的翻身仗回击所有质疑。但最近的几部作品，似乎正在悄悄改写这套公式。\n\n《逆光而行》用八年的时间跨度讲一个女性的职业成长，主角并非每次都赢，很多困境最终也没有"完美答案"；《季风起时》则把镜头对准高考前那段潮湿、迷茫又珍贵的时光。这些作品共同的特点是：它们更愿意相信过程本身的力量。\n\n有评论者指出，这一转向与观众审美的成熟密切相关。当快节奏的"爽"被反复消费后，观众开始渴望更接近真实生活的质感与共鸣。\n\n当然，这并不意味着爽感叙事会消失，而是市场正在走向多元。对创作者而言，如何在真实与戏剧性之间找到平衡，仍是一道长期课题。',
    tags: ['行业', '都市', '观察'],
  },
  {
    id: 'n006',
    title: '《长安十二时》持续出圈，群像塑造的"方法论"',
    date: '2025-10-03',
    author: '影视观察局',
    cover: 'https://readdy.ai/api/search-image?query=vibrant%20ancient%20Chinese%20street%20festival%20at%20dusk%20with%20red%20lanterns%20and%20crowds%20in%20Tang%20dynasty%20clothing%2C%20warm%20golden%20and%20crimson%20tones%2C%20bustling%20cinematic%20scene%2C%20no%20text&width=1200&height=800&seq=news-cover-06&orientation=landscape',
    summary:
      '播出近一年，《长安十二时》仍在多个平台保持高讨论度。它究竟做对了什么？我们试着拆解它的群像叙事。',
    content:
      '距离《长安十二时》首播已近一年，这部古装群像剧依然在多个平台保持着稳定的讨论热度。它的长尾效应，很大程度上来自其扎实的群像塑造。\n\n与传统以主角为绝对中心的结构不同，该剧采用"十二时辰"的时间轴，让一位位小人物依次登场，又彼此交织。卖胡饼的少年、巡夜的武侯、教坊的乐师……每一个看似边缘的角色，都在关键时刻推动着主线。\n\n导演裴远山解释这套方法的起点："我们先把整座城的运行逻辑想清楚，再让角色自然生长出来。长安不是一个背景，它是一个活着的角色。"\n\n正是这种"城市即主角"的思路，让观众在追剧之余，也对唐代的城市生活产生了浓厚兴趣。',
    tags: ['专题', '古装', '群像'],
  },
  {
    id: 'n007',
    title: 'Emma Shaw 谈《沉默的证词》：沉默本身就是一种台词',
    date: '2025-09-30',
    author: '星闻速递',
    cover: 'https://readdy.ai/api/search-image?query=empty%20dramatic%20courtroom%20interior%20with%20a%20single%20spotlight%20on%20the%20witness%20stand%2C%20cold%20desaturated%20grey%20and%20deep%20red%20tones%2C%20tense%20editorial%20mood%2C%20no%20text&width=1200&height=800&seq=news-cover-07&orientation=landscape',
    summary:
      '在《沉默的证词》中饰演辩护律师的 Emma Shaw 分享了拍摄幕后，以及她对"程序正义"这一主题的理解。',
    content:
      '美剧《沉默的证词》中，Emma Shaw 饰演的公设辩护人给观众留下了深刻印象。近日她在一次线上访谈中，分享了拍摄这部剧的感受。\n\n"最让我着迷的，是沉默本身。"她说，"在法庭戏里，台词往往不是重点，真正有力量的是那些停顿、眼神和欲言又止。沉默本身就是一种台词。"\n\n为了贴近角色，她跟随一位真实的公设辩护人工作了两周，旁听了多场庭审。"你会发现，现实中的正义远比剧本复杂。"\n\n谈及剧集探讨的"程序正义"主题，她表示："这部剧没有给出简单答案，它只是把问题摆在你面前。我觉得这正是它诚实的地方。"',
    tags: ['演员动态', '美剧', '访谈'],
  },
  {
    id: 'n008',
    title: '《春日便利店》迎收官：治愈系剧集为何总能长留人心',
    date: '2025-09-27',
    author: '漂亮的姐姐 编辑部',
    cover: 'https://readdy.ai/api/search-image?query=cozy%20warm%20scene%20inside%20a%20small%20convenience%20store%20at%20night%20with%20soft%20orange%20glow%20and%20a%20cup%20of%20hot%20milk%20on%20the%20counter%2C%20comforting%20and%20gentle%20mood%2C%20no%20text&width=1200&height=800&seq=news-cover-08&orientation=landscape',
    summary:
      '没有激烈冲突，没有强情节反转，《春日便利店》却用最日常的温柔留住了一大批观众。治愈系剧集的魅力究竟在哪里？',
    content:
      '《春日便利店》近日迎来收官。这部没有强冲突、没有狗血反转的剧集，却用最日常的温柔留住了一大批观众，评分稳居 8.6。\n\n剧集的故事几乎都发生在一间深夜便利店里：一杯热牛奶、一句晚安、一次偶然的倾诉。它不急于推进情节，而是愿意花时间停留在人物的情绪里。\n\n有观众留言说："看完一集，好像整个人都被轻轻抱了一下。"这种被称为"情绪疗愈"的观剧体验，正是治愈系作品的核心魅力。\n\n心理学者指出，在快节奏的现代生活中，人们对"被理解"的需求日益强烈，而治愈系剧集恰好提供了一个安全、温和的情感出口。这或许就是它总能长留人心的原因。',
    tags: ['资讯', '治愈', '剧评'],
  },
  {
    id: 'n009',
    title: '科幻剧《量子边界》上线：硬核设定下的情感内核',
    date: '2025-09-22',
    author: '影视观察局',
    cover: 'https://readdy.ai/api/search-image?query=abstract%20futuristic%20visual%20of%20glowing%20cobalt%20blue%20quantum%20particle%20waves%20forming%20a%20human%20silhouette%2C%20deep%20space%20black%20background%2C%20high%20tech%20cinematic%20aesthetic%2C%20no%20text&width=1200&height=800&seq=news-cover-09&orientation=landscape',
    summary:
      '《量子边界》用一套严谨的平行世界设定，包裹了一个关于"与自我和解"的故事。硬核科幻的终点，往往还是人心。',
    content:
      '《量子边界》于本月上线，凭借一套相对严谨的平行世界设定迅速吸引了科幻爱好者的注意。\n\n剧中的核心命题是：如果每一个选择都分裂出一个新的世界，那么"更好的自己"是否存在？主角诺拉在穿越层层边界的过程中，遇见了无数个版本的自己，也逐渐意识到，真正的敌人并非某个平行世界，而是自己始终不肯接纳的那部分。\n\n制作团队在视觉上投入了大量心力，用抽象的粒子与光效构建出量子世界的秩序感。有观众评价："特效不炫技，但非常克制。"\n\n正如许多优秀科幻作品一样，《量子边界》的终点并不在技术，而在人心。',
    tags: ['资讯', '美剧', '科幻'],
  },
  {
    id: 'n010',
    title: '年代剧《雪落无声》口碑走高：小城故事里的大时代',
    date: '2025-09-18',
    author: '漂亮的姐姐 编辑部',
    cover: 'https://readdy.ai/api/search-image?query=nostalgic%20snowy%20northern%20Chinese%20town%20with%20an%20old%20steam%20train%20and%20warm%20window%20lights%20at%20dusk%2C%20muted%20blue%20and%20grey%20tones%2C%20cinematic%20period%20mood%2C%20no%20text&width=1200&height=800&seq=news-cover-10&orientation=landscape',
    summary:
      '一部讲述九十年代东北小城往事的年代剧，为何能让年轻观众也看得入迷？答案藏在那些真实到近乎笨拙的细节里。',
    content:
      '年代剧《雪落无声》播出以来口碑持续走高，评分稳定在 9.1。故事发生在上世纪九十年代的东北小城，围绕一段被大雪掩埋的往事展开。\n\n让人意外的是，这部剧不仅吸引了中年观众，也打动了许多年轻人。有二十出头的观众在评论区写道："我爸妈的青春，原来长这个样子。"\n\n打动人的，或许正是那些真实到近乎笨拙的细节：斑驳的厂房、结了冰的水管、饭桌上沉默的父子。剧组为还原年代质感，在实景基地搭建了整片老工业区，连墙上的旧标语都做了考据。\n\n导演陆迁说："我不想拍一个被美化的过去，我想拍一个真实存在过的故乡。"',
    tags: ['资讯', '年代', '剧评'],
  },
];

export const newsTags: string[] = ['全部', '专题', '资讯', '行业', '演员动态', '剧评', '古装', '悬疑', '都市', '美剧', '治愈', '年代', '科幻'];